/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react"

//component
import { sizeofwindows } from "../containers/Function/App.function"

//material ui
import Dialog from "@material-ui/core/Dialog"

class DialogVideo extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hideNav: false,
			overNav: false
		}
	}

	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
	}

	resize() {
		this.setState({ hideNav: sizeofwindows("sm") })
		this.setState({ overNav: sizeofwindows("lg") })
	}
	render() {
		const { handleClose, open, link } = this.props
		let { overNav, hideNav } = this.state
		return (
			<Dialog
				onClose={handleClose}
				open={open}
				maxWidth={false}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<iframe
					title="DialogVideo"
					width={hideNav ? "250px" : overNav ? "945px" : "670px"}
					height={hideNav ? "150px" : overNav ? "532px" : "377px"}
					src={link}
					frameborder="0"
					allow="autoplay"
					allowFullScreen
				/>
			</Dialog>
		)
	}
}

export default DialogVideo
